import {init} from "./ui";

init();
